"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z
    .object({
    editedUserDefinedPresets: zod_1.z
        .record(zod_1.z.string(), zod_1.z.object({
        name: zod_1.z.string(),
        dayOffsetDateFrom: zod_1.z.number(),
        dayOffsetDateTo: zod_1.z.number(),
        selectedValueGroups: zod_1.z.array(zod_1.z.string()),
        valueGroupForMap: zod_1.z.string(),
    }))
        .optional(),
    newUserDefinedPresets: zod_1.z
        .array(zod_1.z.object({
        name: zod_1.z.string(),
        dayOffsetDateFrom: zod_1.z.number(),
        dayOffsetDateTo: zod_1.z.number(),
        selectedValueGroups: zod_1.z.array(zod_1.z.string()),
        valueGroupForMap: zod_1.z.string(),
    }))
        .optional(),
    userDefinedPresetsToDelete: zod_1.z.array(zod_1.z.string()).optional(),
    ignoredSemiosDefinedPresets: zod_1.z.record(zod_1.z.string(), zod_1.z.boolean()).optional(),
    ignoredUserDefinedPresets: zod_1.z.record(zod_1.z.string(), zod_1.z.boolean()).optional(),
})
    .refine((args) => !!Object.keys(args).length, {
    message: 'Request object must contain at least one argument',
});
exports.path = '/app-presets-management';
//# sourceMappingURL=index.js.map